import { render, staticRenderFns } from "./cellInfo.vue?vue&type=template&id=6bab628c&scoped=true"
import script from "./cellInfo.vue?vue&type=script&lang=js"
export * from "./cellInfo.vue?vue&type=script&lang=js"
import style0 from "./cellInfo.vue?vue&type=style&index=0&id=6bab628c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bab628c",
  null
  
)

export default component.exports